module.exports = __webpack_public_path__ + "img/confirm-location-icon.7e0a2bdc.svg";